import useTranslate from "ui/locale/hooks/useTranslate";
import { RoleSelectProps } from "./RoleSelect.types";
import { RoleSelectRoot } from "./RoleSelect.styles";
import { useControlled } from "@commonlibs";

export default function RoleSelect({ roleKey, onRoleSelected, options, ...rest }: RoleSelectProps): JSX.Element {
    const translate = useTranslate();

    function handleOnRoleSelected(roleKey: string | undefined) {
        if (roleKey) onRoleSelected?.(roleKey);
    }

    const handleControlledChange = onRoleSelected ? handleOnRoleSelected : undefined;

    const [value, setValue] = useControlled<string | undefined>(undefined, roleKey, handleControlledChange);

    return (
        <RoleSelectRoot
            options={options}
            value={value}
            onChange={setValue}
            placeholder={translate("chooseRole")}
            rounded
            variant="outlined"
            {...rest}
        />
    );
}
